/* 🤖 this file was generated by svg-to-ts */
export const fthrInfo: {
    name: 'fthr-info';
    data: string;
} = {
    name: 'fthr-info',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-info" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>`,
};
